/*eslint-disable*/
import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";

// core components
import downloadStyle from "assets/jss/material-kit-react/views/componentsSections/downloadStyle.jsx";


class SectionFooter extends React.Component {
  render() {
    const { classes, dataButtons, dataCustom } = this.props;
    const dataTitle = dataCustom.filter(item => item.custom_fields === 'title_contact');
    const dataBody = dataCustom.filter(item => item.custom_fields === 'body_contact');
    const dataButtonsFilter = dataButtons.filter(item => item.id === 0);
    const style = {
      paddingTop: "10px"
    }

    return (
      <div style={style} className={classes.section}>
        <div className={classes.container}>

          <GridContainer className={classes.textCenter} justify="center">

              <GridItem xs={12} sm={12} md={8}>
                <h2>{dataTitle.map(item => item.value)}</h2>
                <h4>{dataBody.map(item => item.value)}</h4>
              </GridItem>

              <GridItem xs={12} sm={8} md={6}>
              {dataButtonsFilter.map((item) =>
                  <Button
                    key={item.id}
                    color="primary"
                    size="lg"
                    href={item.link}
                    target="_self"
                  >
                    {item.text}
                  </Button>
              )}
              </GridItem>

          </GridContainer>

        </div>
      </div>
    );
  }
}

export default withStyles(downloadStyle)(SectionFooter);



// WEBPACK FOOTER //
// ./src/views/AboutUs/Sections/SectionFooter.jsx